document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap !== 'undefined') {
    gsap.set('body', { autoAlpha: 1 })
  } else {
    // Fallback in case GSAP fails to load
    document.body.style.opacity = '1'
    document.body.style.visibility = 'visible'
  }
})
